<template>
  <div class="mb-3">
    <label :for="id">{{ name }}</label>
    <select :name="id" :multiple="multiple" class="form-select" :id="id" :value="modelValue" @change="onChange">
      <option v-for="option in options" :key="option.value" :value="option.value" :selected="(option.selected)">{{option.label}}</option>
    </select>
  </div>
</template>
<script setup>
import {defineProps, defineEmits} from 'vue';
const props = defineProps({
  id: String,
  name: String,
  multiple: Boolean,
  options: [{value: String, label: String, selected: Boolean}],
  modelValue: [Array, String]
})
const emit = defineEmits(['update:modelValue']);
const onChange = (event) => {
  if (props.multiple) {
    const selectedOptions = Array.from(event.target.selectedOptions, option => option.value);
    const uniqueOptions = Array.from(new Set(selectedOptions));
    emit('update:modelValue', uniqueOptions);
  } else {
    emit('update:modelValue', event.target.value);
  }
};
</script>
